/* ── ALATIN01 Shopify tema ───────────────────────────────
   Ponaša se kao alatin01.com: tema, meni, slajder, AJAX korpa. */
(function () {
  'use strict';

  var A = window.ALATIN || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function money(cents) {
    // prodavnica je na formatu {{amount_with_comma_separator}} → 1.234,56
    var parts = (cents / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  // ── TOAST ──────────────────────────────────────────────
  var toastTimer;
  function showToast(msg, isError) {
    var el = $('#alatinToast');
    if (!el) return;
    el.textContent = msg;
    el.className = 'alatin-toast show' + (isError ? ' error' : '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.className = 'alatin-toast'; }, 2600);
  }

  // ── TEMA ───────────────────────────────────────────────
  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    $$('[data-theme-toggle]').forEach(function (b) { b.textContent = theme === 'light' ? '🌙' : '☀'; });
  }
  applyTheme(localStorage.getItem('alatin_theme') || 'light');

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (!t) return;
    var next = document.documentElement.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
    localStorage.setItem('alatin_theme', next);
    applyTheme(next);
  });

  // ── MOBILNI MENI ───────────────────────────────────────
  function openMob() {
    var m = $('#mobMenu'), o = $('#mobOverlay');
    if (m) m.classList.add('open');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMob() {
    var m = $('#mobMenu'), o = $('#mobOverlay');
    if (m) m.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('#mobToggle')) { openMob(); return; }
    if (e.target.closest('[data-mob-close]')) { closeMob(); }
  });

  // ── MOBILNA PRETRAGA ───────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mob-search-toggle]')) {
      var row = $('#mobSearchRow');
      if (!row) return;
      row.classList.toggle('open');
      if (row.classList.contains('open')) { var i = $('#mobSearchInput'); if (i) i.focus(); }
    }
    if (e.target.closest('[data-mob-search-close]')) {
      e.preventDefault();
      var r = $('#mobSearchRow');
      if (r) r.classList.remove('open');
    }
  });

  // ── PADAJUĆI MENI KATEGORIJA ───────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cat-drop-toggle]');
    var dd = $('#catDropdown');
    if (!dd) return;
    if (btn) {
      e.preventDefault();
      var open = dd.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var arrow = $('#catDropArrow');
      if (arrow) arrow.style.transform = open ? 'rotate(180deg)' : '';
    } else if (!e.target.closest('#catDropdown')) {
      dd.classList.remove('open');
      var b = $('#catDropBtn');
      if (b) b.setAttribute('aria-expanded', 'false');
      var ar = $('#catDropArrow');
      if (ar) ar.style.transform = '';
    }
  });

  // ── HERO SLAJDER ───────────────────────────────────────
  (function heroSlider() {
    var hero = $('#heroSection');
    if (!hero) return;
    var track = $('#heroSlides', hero);
    var slides = $$('.hero-slide', hero);
    var dots = $$('[data-hero-dot]', hero);
    if (!track || slides.length < 2) return;

    var idx = 0, timer = null;
    var delay = (parseInt(hero.dataset.autoplay, 10) || 0) * 1000;

    // isti mehanizam kao na alatin01.com — pomak trake, ne fade
    function go(n) {
      idx = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    function start() { if (delay > 0) { stop(); timer = setInterval(function () { go(idx + 1); }, delay); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    hero.addEventListener('click', function (e) {
      if (e.target.closest('[data-hero-next]')) { go(idx + 1); start(); }
      else if (e.target.closest('[data-hero-prev]')) { go(idx - 1); start(); }
      else {
        var dot = e.target.closest('[data-hero-dot]');
        if (dot) { go(parseInt(dot.dataset.heroDot, 10)); start(); }
      }
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    // swipe na mobilnom
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { go(dx < 0 ? idx + 1 : idx - 1); start(); }
      x0 = null;
    }, { passive: true });

    go(0);
    start();
  })();

  // ── AJAX KORPA ─────────────────────────────────────────
  function refreshCart() {
    return fetch(A.routes.cart, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var total = $('[data-drawer-total]');
        if (total) total.textContent = money(cart.total_price) + ' KM';
        var foot = $('[data-drawer-foot]');
        if (foot) foot.hidden = cart.item_count === 0;
        renderShipBar(cart);
        renderDrawer(cart);
        return cart;
      });
  }

  function renderShipBar(cart) {
    var box = $('[data-drawer-ship]');
    if (!box) return;
    var threshold = (A.freeShipThreshold || 0) * 100;
    if (threshold <= 0 || cart.item_count === 0) { box.hidden = true; return; }
    box.hidden = false;
    var txt = $('[data-drawer-ship-txt]', box), bar = $('[data-drawer-ship-bar]', box);
    if (cart.total_price >= threshold) {
      txt.className = 'ship-progress-txt ok';
      txt.textContent = '\uD83C\uDF89 ' + A.strings.shipUnlocked;
      bar.style.width = '100%';
    } else {
      txt.className = 'ship-progress-txt';
      txt.innerHTML = '\uD83D\uDE9A ' + A.strings.shipRemaining + ' <strong>' +
        money(threshold - cart.total_price) + ' KM</strong> ' + A.strings.shipSuffix;
      bar.style.width = Math.round(cart.total_price * 100 / threshold) + '%';
    }
  }

  function renderDrawer(cart) {
    var body = $('[data-drawer-body]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cd-empty"><span>🛒</span><p>' + A.strings.emptyCart + '</p></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" width="60" height="60" loading="lazy">' : '';
      return '<div class="cd-item" data-key="' + it.key + '">' +
        '<a class="cd-item-img" href="' + it.url + '">' + img + '</a>' +
        '<div class="cd-item-body">' +
          '<a class="cd-item-name" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title ? '<div class="cd-item-var">' + it.variant_title + '</div>' : '') +
          '<div class="cd-item-row">' +
            '<div class="qty-sel qty-sm">' +
              '<button type="button" class="qbtn" data-drawer-minus aria-label="\u2212">\u2212</button>' +
              '<input class="qinput" type="number" inputmode="numeric" min="0" value="' + it.quantity + '" data-drawer-qty aria-label="' + A.strings.quantity + '">' +
              '<button type="button" class="qbtn" data-drawer-plus aria-label="+">+</button>' +
            '</div>' +
            '<div class="cd-item-price">' + money(it.final_line_price) + ' KM</div>' +
          '</div>' +
          (it.quantity > 1 ? '<div class="cd-item-unit">' + money(it.final_price) + ' KM \u00d7 ' + it.quantity + '</div>' : '') +
        '</div>' +
        '<button type="button" class="cd-item-x" data-drawer-remove="' + it.key + '" aria-label="✕">✕</button>' +
      '</div>';
    }).join('');
  }

  function openDrawer() {
    var d = $('#cartDrawer'), o = $('.cart-drawer-overlay');
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (o) { o.hidden = false; o.classList.add('open'); }
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('#cartDrawer'), o = $('.cart-drawer-overlay');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) { o.classList.remove('open'); o.hidden = true; }
    document.body.style.overflow = '';
  }

  function changeDrawerLine(key, qty) {
    return fetch(A.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshCart);
  }

  document.addEventListener('change', function (e) {
    var qin = e.target.closest('[data-drawer-qty]');
    if (!qin) return;
    var line = qin.closest('.cd-item');
    changeDrawerLine(line.dataset.key, Math.max(0, parseInt(qin.value, 10) || 0));
  });

  function addToCart(variantId, qty) {
    return fetch(A.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || err.message || A.strings.error); });
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    // dodaj u korpu s kartice
    var btn = e.target.closest('[data-add-to-cart]');
    if (btn) {
      e.preventDefault();
      if (btn.dataset.needsOptions) { window.location.href = btn.dataset.needsOptions; return; }
      btn.disabled = true;
      addToCart(btn.dataset.variantId, 1)
        .then(function () { return refreshCart(); })
        .then(function () { showToast(A.strings.added); openDrawer(); })
        .catch(function (err) { showToast(err.message, true); })
        .finally(function () { btn.disabled = false; });
      return;
    }

    // brza kupovina → korpa pa odmah checkout
    var qb = e.target.closest('[data-quick-buy]');
    if (qb) {
      e.preventDefault();
      if (qb.dataset.needsOptions) { window.location.href = qb.dataset.needsOptions; return; }
      qb.disabled = true;
      addToCart(qb.dataset.variantId, 1)
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { showToast(err.message, true); qb.disabled = false; });
      return;
    }

    if (e.target.closest('[data-cart-open]')) {
      // desktop: otvori ladicu umjesto navigacije (mobilni ide na /cart)
      if (window.innerWidth > 760) { e.preventDefault(); refreshCart().then(openDrawer); }
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var step = e.target.closest('[data-drawer-plus], [data-drawer-minus]');
    if (step) {
      e.preventDefault();
      var line = step.closest('.cd-item');
      var qin = $('[data-drawer-qty]', line);
      var cur = parseInt(qin.value, 10) || 1;
      changeDrawerLine(line.dataset.key, step.hasAttribute('data-drawer-plus') ? cur + 1 : Math.max(0, cur - 1));
      return;
    }

    var rm = e.target.closest('[data-drawer-remove]');
    if (rm) {
      e.preventDefault();
      changeDrawerLine(rm.dataset.drawerRemove, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMob(); }
  });

  // ── LISTA ŽELJA (localStorage) ─────────────────────────
  function getWish() {
    try {
      var raw = JSON.parse(localStorage.getItem('alatin_wish') || '[]');
      // stari format je bio niz brojeva — odbaci ga
      return raw.filter(function (x) { return x && typeof x === 'object' && x.h; });
    } catch (err) { return []; }
  }
  function saveWish(w) { localStorage.setItem('alatin_wish', JSON.stringify(w)); }

  function paintWish() {
    var w = getWish();
    var handles = w.map(function (x) { return x.h; });
    $$('[data-wish-count]').forEach(function (el) {
      el.textContent = w.length;
      el.hidden = w.length === 0;
    });
    $$('[data-wish-toggle]').forEach(function (b) {
      b.classList.toggle('active', handles.indexOf(b.dataset.wishToggle) !== -1);
    });
    renderWishDrawer(w);
  }

  function renderWishDrawer(w) {
    var body = $('[data-wish-body]');
    if (!body) return;
    if (!w.length) {
      body.innerHTML = '<div class="cd-empty"><span>&#9825;</span><p>' + A.strings.emptyWish + '</p></div>';
      return;
    }
    body.innerHTML = w.map(function (it) {
      var img = it.i ? '<img src="' + it.i + '" alt="" width="60" height="60" loading="lazy">' : '';
      return '<div class="cd-item">' +
        '<a class="cd-item-img" href="' + it.u + '">' + img + '</a>' +
        '<div class="cd-item-body">' +
          '<a class="cd-item-name" href="' + it.u + '">' + it.t + '</a>' +
          '<div class="cd-item-price">' + it.p + ' KM</div>' +
        '</div>' +
        '<button type="button" class="cd-item-x" data-wish-toggle="' + it.h + '" aria-label="&#10005;">&#10005;</button>' +
      '</div>';
    }).join('');
  }

  function openWish() {
    var d = $('#wishDrawer'), o = $('[data-wish-close].cart-drawer-overlay');
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (o) { o.hidden = false; o.classList.add('open'); }
    document.body.style.overflow = 'hidden';
  }
  function closeWish() {
    var d = $('#wishDrawer'), o = $('[data-wish-close].cart-drawer-overlay');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) { o.classList.remove('open'); o.hidden = true; }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wish-open]')) { e.preventDefault(); paintWish(); openWish(); return; }
    if (e.target.closest('[data-wish-close]')) { closeWish(); return; }

    var b = e.target.closest('[data-wish-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = b.dataset.wishToggle;
    var w = getWish();
    var i = -1;
    w.forEach(function (x, n) { if (x.h === handle) i = n; });
    if (i === -1) {
      var payload = null;
      try { payload = JSON.parse(b.dataset.wish); } catch (err) { payload = null; }
      if (!payload) return;
      w.push(payload);
      showToast(A.strings.wishAdded);
    } else {
      w.splice(i, 1);
      showToast(A.strings.wishRemoved);
    }
    saveWish(w);
    paintWish();
  });
  paintWish();

  // ── PREDIKTIVNA PRETRAGA ───────────────────────────────
  (function predictive() {
    var input = $('#globalSearch');
    var drop = $('#searchDrop');
    if (!input || !drop) return;
    var timer, ctrl;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { drop.hidden = true; drop.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var url = A.routes.predictive_search + '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: ctrl.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = doc.querySelector('[data-predictive-results]');
            drop.innerHTML = results ? results.innerHTML : '';
            drop.hidden = !drop.innerHTML.trim();
          })
          .catch(function () { /* prekinut zahtjev */ });
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.search-bar')) { drop.hidden = true; }
    });
  })();

  // ── STRANICA PROIZVODA ─────────────────────────────────
  (function productPage() {
    var form = $('#ProductForm');

    // galerija
    document.addEventListener('click', function (e) {
      var th = e.target.closest('[data-gallery-thumb]');
      if (!th) return;
      var main = $('#galleryMainImg');
      if (main) main.src = th.dataset.full;
      $$('[data-gallery-thumb]').forEach(function (t) { t.classList.toggle('active', t === th); });
    });

    // tabovi
    document.addEventListener('click', function (e) {
      var tb = e.target.closest('[data-tab]');
      if (!tb) return;
      $$('.tab-btn').forEach(function (b) { b.classList.toggle('active', b === tb); });
      $$('.tab-pane').forEach(function (p) { p.classList.toggle('active', p.id === 'tab-' + tb.dataset.tab); });
    });

    // količina
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var input = $('#qtyInput');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, plus ? v + 1 : v - 1);
    });

    // podijeli
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-share]')) return;
      if (navigator.share) {
        navigator.share({ title: document.title, url: location.href }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(location.href).then(function () { showToast('Link kopiran!'); });
      }
    });

    if (!form) return;

    // varijante
    var dataEl = $('[data-variant-data]');
    if (dataEl) {
      var variants = JSON.parse(dataEl.textContent);
      var selects = $$('[data-variant-option]');
      var hidden = $('[data-variant-input]');

      function updateVariant() {
        var chosen = selects.map(function (s) { return s.value; });
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        if (!match) return;
        hidden.value = match.id;

        var price = $('[data-price]');
        if (price) price.textContent = money(match.price);
        var cmp = $('[data-compare]');
        var saved = $('[data-saved]');
        if (cmp) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            cmp.textContent = money(match.compare_at_price) + ' KM';
            cmp.hidden = false;
            if (saved) { saved.textContent = 'Uštedite ' + money(match.compare_at_price - match.price) + ' KM'; saved.hidden = false; }
          } else {
            cmp.hidden = true;
            if (saved) saved.hidden = true;
          }
        }
        var sku = $('[data-sku]');
        if (sku && match.sku) sku.textContent = match.sku;

        var atc = $('[data-atc]'), buy = $('[data-buy-now]');
        if (atc) {
          atc.disabled = !match.available;
          var lbl = $('[data-atc-label]', atc);
          if (lbl) lbl.textContent = match.available ? A.strings.addToCart : A.strings.soldOut;
        }
        if (buy) buy.disabled = !match.available;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

      document.addEventListener('click', function (e) {
        var pill = e.target.closest('.variant-pill');
        if (!pill) return;
        var group = pill.closest('.variant-group');
        var select = group && $('[data-variant-option]', group);
        if (!select) return;
        select.value = pill.getAttribute('data-pill-value');
        $$('.variant-pill', group).forEach(function (p) { p.classList.toggle('active', p === pill); });
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // AJAX dodavanje sa stranice proizvoda
    function formQty() { return parseInt(($('#qtyInput') || {}).value, 10) || 1; }
    function formVariant() { return $('[data-variant-input]', form).value; }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var atc = $('[data-atc]', form);
      if (atc) atc.disabled = true;
      addToCart(formVariant(), formQty())
        .then(refreshCart)
        .then(function () { showToast(A.strings.added); openDrawer(); })
        .catch(function (err) { showToast(err.message, true); })
        .finally(function () { if (atc) atc.disabled = false; });
    });

    // "Kupi odmah" — prije je bio submit s name="checkout" unutar {% form 'product' %},
    // a to ide na /cart/add koji ignoriše "checkout" i baci kupca na /cart uz reload.
    var buyNow = $('[data-buy-now]', form);
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        buyNow.disabled = true;
        addToCart(formVariant(), formQty())
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { showToast(err.message, true); buyNow.disabled = false; });
      });
    }

    // brojač gledatelja — samo ako je uključen u temi
    var vc = $('[data-viewers]');
    if (vc) {
      var n = 4 + Math.floor(Math.random() * 12);
      vc.textContent = n;
      setInterval(function () {
        n = Math.max(3, Math.min(22, n + (Math.random() < 0.5 ? -1 : 1)));
        vc.textContent = n;
      }, 9000);
    }
  })();

  // ── KOLEKCIJA: filteri i sortiranje ────────────────────
  (function collectionPage() {
    var form = $('[data-facet-form]');

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sidebar-open]')) {
        var sb = $('#sidebar'), ov = $('#sbOverlay');
        if (sb) sb.classList.add('open');
        if (ov) ov.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
      if (e.target.closest('[data-sidebar-close]')) {
        var sb2 = $('#sidebar'), ov2 = $('#sbOverlay');
        if (sb2) sb2.classList.remove('open');
        if (ov2) ov2.classList.remove('open');
        document.body.style.overflow = '';
      }
    });

    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    if (!form) return;
    var debounce;
    form.addEventListener('change', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { form.submit(); }, 250);
    });
  })();

  // ── STRANICA KORPE ─────────────────────────────────────
  (function cartPage() {
    if (!$('[data-cart-form]')) return;

    function changeLine(key, qty) {
      return fetch(A.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    }

    document.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var input = $('[data-line-qty]', row);
      var key = row.dataset.key;
      if (e.target.closest('[data-line-plus]')) changeLine(key, (parseInt(input.value, 10) || 1) + 1);
      else if (e.target.closest('[data-line-minus]')) changeLine(key, Math.max(0, (parseInt(input.value, 10) || 1) - 1));
      else if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      var row = input.closest('[data-cart-item]');
      changeLine(row.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    });
  })();

  // ── NA VRH ─────────────────────────────────────────────
  (function scrollTop() {
    var btn = $('[data-scroll-top]');
    if (!btn) return;
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    window.addEventListener('scroll', function () {
      btn.classList.toggle('show', window.scrollY > 500);
    }, { passive: true });
  })();

  // ── COD APLIKACIJA: samo jedno "Naruči odmah" ──────────
  // EasySell ubacuje svoje dugme na više mjesta na stranici proizvoda
  // (ispod cijene, u red s "Dodaj u korpu", ponekad i treći put).
  // Tema ne kontroliše aplikaciju, pa ovdje ostaje samo prvo dugme.
  (function dedupeCodButtons() {
    var scope = document.querySelector('.product-layout[data-dedupe-cod]');
    if (!scope) return;

    var RX = /naru[čc]i\s+odmah|kupi\s+odmah\s+—\s+pla/i;

    function inFixed(el) {
      for (var n = el; n && n !== document.body; n = n.parentElement) {
        if (window.getComputedStyle(n).position === 'fixed') return true;
      }
      return false;
    }

    // sakriva i omotač ako u njemu nema ničeg drugog
    function hide(el) {
      var node = el;
      while (node.parentElement && node.parentElement !== scope &&
             node.parentElement.children.length === 1 &&
             !node.parentElement.classList.contains('qty-atc')) {
        node = node.parentElement;
      }
      node.setAttribute('data-cod-dupe', '');
      node.style.display = 'none';
    }

    function run() {
      var hits = $$('button, a, [role="button"], #es-popup-button, .es-popup-button', scope).filter(function (el) {
        if (el.hasAttribute('data-cod-dupe') || el.closest('[data-cod-dupe]')) return false;
        if (el.hasAttribute('data-atc') || el.hasAttribute('data-buy-now')) return false;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        return t.length <= 40 && RX.test(t) && !inFixed(el);
      });
      // kod ugniježđenih poklapanja (dugme u linku) računa se ono unutrašnje
      hits = hits.filter(function (el) {
        return !hits.some(function (o) { return o !== el && el.contains(o); });
      });
      hits.slice(1).forEach(hide);
    }

    run();
    // aplikacija ubacuje dugmad naknadno, pa se prati promjena DOM-a
    var obs = new MutationObserver(function () { run(); });
    obs.observe(scope, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  })();

  // ── OPIS PROIZVODA: sirov <p> tekst → naslovi, kvačice, tabela ──
  // Opisi dolaze iz WooCommerce importa kao niz golih <p> odlomaka:
  // naslovi sekcija, "✔ stavka" redovi i "Naziv: vrijednost" specifikacije
  // su svi isti <p>. Ovdje se to podiže u pravu strukturu da CSS ima šta stilizovati.
  (function richDescription() {
    var panes = ['tab-desc', 'tab-specs'].map(function (id) { return document.getElementById(id); })
      .filter(Boolean);
    if (!panes.length) return;

    var HEADINGS = [
      'prednosti proizvoda', 'prednosti', 'tehničke specifikacije', 'tehnicke specifikacije',
      'specifikacije', 'specifikacija', 'sadržaj paketa', 'sadrzaj paketa', 'u kompletu',
      'karakteristike', 'opis proizvoda', 'opis', 'primjena', 'namjena', 'napomena', 'napomene',
      'garancija', 'dodatne informacije', 'zašto ovaj proizvod', 'zasto ovaj proizvod'
    ];
    var BULLET = /^\s*(?:&nbsp;|\s)*[✔✓☑✅•●▪◾■◦★–—-]\s+/;
    var SPEC = /^([^:]{2,45}):\s*(.+)$/;

    function kids(el) { return Array.prototype.slice.call(el.children); }
    function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
    function norm(t) { return t.toLowerCase().replace(/[:\s]+$/, '').trim(); }

    function makeHeadings(pane) {
      kids(pane).forEach(function (el) {
        if (el.tagName !== 'P') return;
        var t = txt(el);
        if (!t || t.length > 60 || BULLET.test(t)) return;
        if (HEADINGS.indexOf(norm(t)) === -1) return;
        var h = document.createElement('h3');
        h.className = 'rte-h';
        h.textContent = t.replace(/\s*:\s*$/, '');
        el.parentNode.replaceChild(h, el);
      });
    }

    // skuplja uzastopne <p> koji zadovoljavaju test i predaje ih graditelju
    function runs(pane, test, min, build) {
      var run = [];
      function flush() {
        if (run.length >= min) {
          var node = build(run);
          if (node) {
            run[0].parentNode.insertBefore(node, run[0]);
            run.forEach(function (p) { p.parentNode.removeChild(p); });
          }
        }
        run = [];
      }
      kids(pane).forEach(function (el) {
        if (el.tagName === 'P' && test(el)) run.push(el);
        else flush();
      });
      flush();
    }

    function checkList(pane) {
      runs(pane, function (el) { return BULLET.test(txt(el)); }, 2, function (run) {
        var ul = document.createElement('ul');
        ul.className = 'rte-checks';
        run.forEach(function (p) {
          var li = document.createElement('li');
          li.innerHTML = p.innerHTML.replace(BULLET, '');
          ul.appendChild(li);
        });
        return ul;
      });
    }

    function specRow(table, label, value) {
      var tr = table.insertRow(-1);
      var td1 = tr.insertCell(-1), td2 = tr.insertCell(-1);
      td1.textContent = label;
      td2.textContent = value;
    }

    function specTables(pane) {
      runs(pane, function (el) {
        var t = txt(el);
        var m = t.match(SPEC);
        return !!m && m[2].length <= 80 && !BULLET.test(t);
      }, 3, function (run) {
        var table = document.createElement('table');
        table.className = 'rte-specs';
        run.forEach(function (p) {
          var m = txt(p).match(SPEC);
          specRow(table, m[1].trim(), m[2].trim());
        });
        return table;
      });
    }

    // usamljeni "Naziv: vrijednost" odmah iza tabele (npr. "Garancija: 1") ide u tabelu
    function absorbStrays(pane) {
      kids(pane).forEach(function (el) {
        if (el.tagName !== 'P') return;
        var prev = el.previousElementSibling;
        if (!prev || prev.tagName !== 'TABLE') return;
        var m = txt(el).match(SPEC);
        if (!m || m[2].length > 80) return;
        specRow(prev, m[1].trim(), m[2].trim());
        el.parentNode.removeChild(el);
      });
    }

    // isti podaci su često i u odlomcima i u tabeli iz opisa — izbaci duplikat
    function dropDuplicateSpecs(pane) {
      var all = Array.prototype.slice.call(pane.querySelectorAll('table'));
      var native = all.filter(function (t) { return !t.classList.contains('rte-specs'); });
      if (!native.length) return;

      var known = {};
      native.forEach(function (t) {
        Array.prototype.slice.call(t.rows).forEach(function (r) {
          if (r.cells[0]) known[norm(r.cells[0].textContent || '')] = true;
        });
      });

      all.filter(function (t) { return t.classList.contains('rte-specs'); }).forEach(function (t) {
        var rows = Array.prototype.slice.call(t.rows);
        var dupes = rows.filter(function (r) { return r.cells[0] && known[norm(r.cells[0].textContent || '')]; });
        if (!rows.length || dupes.length < rows.length) return;
        var prev = t.previousElementSibling;
        if (prev && prev.classList && prev.classList.contains('rte-h')) prev.parentNode.removeChild(prev);
        t.parentNode.removeChild(t);
      });
    }

    // prvi odlomak je često samo prepisan naziv proizvoda — višak iznad naslova stranice
    function dropTitleEcho(pane) {
      var title = pane.getAttribute('data-desc-title');
      if (!title) return;
      function key(t) { return t.toLowerCase().replace(/[^0-9a-zà-ž]+/g, ''); }
      var want = key(title);
      if (want.length < 8) return;
      kids(pane).slice(0, 3).forEach(function (el) {
        if (el.tagName !== 'P') return;
        var got = key(txt(el));
        if (got.indexOf(want) === 0 && got.length - want.length <= 14) el.parentNode.removeChild(el);
      });
    }

    panes.forEach(function (pane) {
      dropTitleEcho(pane);
      makeHeadings(pane);
      checkList(pane);
      specTables(pane);
      absorbStrays(pane);
      dropDuplicateSpecs(pane);
    });
  })();

  // početno stanje ladice
  if ($('#cartDrawer')) refreshCart();
})();
